module.exports = __webpack_public_path__ + "static/media/services-genetic-test-thc.97759285.jpeg";